import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m40 40 20 40-24-8zM160 40l-20 40 24-8z" }, null, -1),
    _createElementVNode("path", { d: "M40 90q0-30 60-30t60 30v50q-30 30-60 30t-60-30Z" }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M60 96h30l-15 20zM110 96h30l-15 20zM60 138q40-8 80 0l-10 14-6-8-8 8-8-8-8 8-8-8-8 8-8-8-6 8Z"
    }, null, -1)
  ]))]))
}
export default { render: render }